module.exports = __webpack_public_path__ + "images/help/avatars/songhui-cd734f01f2262a5dc2bae3977c548052.jpg";